import React, { useState } from "react";
import "./settings.css";

const Settings = () => {
  const [username, setUsername] = useState("JohnDoe");
  const [email, setEmail] = useState("johndoe@example.com");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [darkMode, setDarkMode] = useState(false);
  const [message, setMessage] = useState("");

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
  };

  const handlePasswordChange = () => {
    if (password !== confirmPassword) {
      setMessage("Passwords do not match!");
      return;
    }
    setMessage("Password updated successfully!");
    setPassword("");
    setConfirmPassword("");
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle("dark-mode");
  };

  return (
    <div className="settings-container">
      <h1 className="settings-title">Account Settings</h1>

      <div className="settings-section">
        <label>Username</label>
        <input type="text" value={username} onChange={handleInputChange(setUsername)} />

        <label>Email</label>
        <input type="email" value={email} onChange={handleInputChange(setEmail)} />
      </div>

      <div className="settings-section">
        <label>New Password</label>
        <input type="password" value={password} onChange={handleInputChange(setPassword)} />

        <label>Confirm Password</label>
        <input type="password" value={confirmPassword} onChange={handleInputChange(setConfirmPassword)} />

        <button onClick={handlePasswordChange} className="settings-btn">Update Password</button>
        <p className="settings-message">{message}</p>
      </div>

      <div className="settings-section">
        <label className="toggle-label">Dark Mode</label>
        <label className="switch">
          <input type="checkbox" checked={darkMode} onChange={toggleDarkMode} />
          <span className="slider round"></span>
        </label>
      </div>
    </div>
  );
};

export default Settings;
